import { Dashboard } from '@components/dashboard';
import { Head } from '@components/head';
import { Container, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

export const DashboardPage: FunctionComponent = () => {
  return (
    <>
      <Head title="Dashboard" />
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Dashboard
        </Typography>
        <Dashboard />
      </Container>
    </>
  );
};
